module.exports = __webpack_public_path__ + "img/splash.dacy.7bc6275d.png";